// removed by extract-text-webpack-plugin
module.exports = {"NavigationItemFirst":"aKLhB2SxWZhOTgbZJCszj","NavigationItemLogout":"_3INI--nMOypUwIzp7O5h75","White":"mUCdSRAUPDVn0v99jxhAY","NavigationItemWoLink":"_1Af2AZm7sg8ussoZQDQAYz","active":"_2zJdO1aspVrGyx-JgFjMYX","NavigationItemSecond":"_3Xup_WNvM9QtMbufUWtp4n","Support":"_1FZ30H0aE12TbWL9lp6NL5","QR":"_2hZZy8O0T_ymMpjR4emBPh","One":"_2lLwSk0DNrYqvd8eO7D1xH","NavigationItem":"_23bcunS9Qq8yRK8U15WWqn","DocNavigationItem":"_3tOh2P5gaMmtE5rfJ_Ox1M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 207
// module chunks = 0